<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">
        <div class="page-header">
            <div class="page-title">
                <h2 *ngIf="role=='adm' || role=='asst'"><i class="flaticon-dollar-coin text-success"></i><b> Ventes réalisées par : </b> {{commercialFullname}}</h2>
            </div>
        </div>
        <div class="accordion" id="accordionExample" style="background: none;">
            <fieldset class="p-3 mb-3" style="border-radius: 15px;background-color: aliceblue;">
                <legend class="pl-3 pr-3" style="width: auto;">Période</legend>
                    <form [formGroup]="advancedSearchForm">
                    <div class="row">
                        <div class="col">
                            <div class="row " *ngIf="role!='adm' || role!='asst'">
                                <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" >
                                    <div class="form-group text-left mb-0">
                                        <label class="control-label text-black text-left" for="start_date">Du </label>
                                    </div>
                                    <div class="row">                                            
                                        <div class="col-md-12 col-sm-12 mx-auto">
                                            <div class="form-inline my-2 my-lg-0">
                                                <input class="form-control br-30 w-100" type="datetime-local" name="start_date" id="start_date" 
                                                    [max]="advancedSearchForm.get('end_date')?.value" formControlName="start_date">
                                            </div>
                                        </div>
                                    </div>
                                </div>                                        
                                <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" *ngIf="role!='cmrc'">
                                    <div class="form-group text-left mb-0">
                                        <label class="control-label text-black text-left" for="end_date">Au </label>
                                    </div>
                                    <div class="row">                                            
                                        <div class="col-md-12 col-sm-12 mx-auto">
                                            <div class="form-inline my-2 my-lg-0">
                                                <input class="form-control br-30 w-100" type="datetime-local" name="end_date" id="end_date" 
                                                    [min]="advancedSearchForm.get('start_date')?.value" formControlName="end_date"
                                                    [required]="advancedSearchForm.get('start_date')?.value">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-4 margin-bottom-20 country-search" [ngClass]="{'col-lg-2': role=='adm','col-lg-3': role=='cmrc'}">
                            <div class="form-group text-left mb-0" *ngIf="!mobile">
                                <label class="control-label text-black text-left" for="country"></label>
                            </div>
                            <div class="row">                                            
                                <div class="col-md-12 col-sm-12 mx-auto">
                                    <button type="button" class="btn btn-gradient-dark mb-2 mr-2 mt-2  col-sm-12" 
                                        [disabled]="areAllControlsEmpty()" (click)="search()">
                                        <i class="flaticon-search-1 mr-2"></i> Rechercher
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </fieldset>
            <div class="row" id="cancel-row">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing" >
                    <div class="statbox widget box box-shadow">
                        <div class="widget-content widget-content-area">
                            <div *ngIf="loading_sales_search" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;margin-bottom: 20%;"></div>
                            <div class="table-responsive mb-4"  *ngIf="!loading_sales_search">
                                <table  id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                    <thead >
                                        <tr>
                                            <th>Date de saisie</th>
                                            <th>Client</th>
                                            <th>Désignation</th>
                                            <th>Famille</th>
                                            <th>Prix Unitaire</th>
                                            <th>Quantité</th> 
                                            <th>Total HT</th>  
                                            <th>TVA</th>  
                                            <th>Total TTC</th>  
                                            <th>Origine</th>   
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let sale of salesDataFiltred">
                                            <ng-container >
                                                <td style="font-size: small !important;">
                                                    <b>{{sale.saleDate | date: 'dd/MM/yyyy- HH:mm' || '---'}}</b></td>
                                                <td> <a class="text-primary" href="/customer/fromshow;cs={{sale.customerUuid}}">{{sale.customer}}</a></td>
                                                <td>{{sale.designation || '---'}}</td>
                                                <td>{{sale.famille || '---'}}</td>
                                                <td class="text-right">{{sale.prixUnitaire ? (sale.prixUnitaire) : '---'}}</td>
                                                <td class="text-center">{{sale.quantite || '---'}}</td>
                                                <td class="text-right">{{sale.totalHt ? (sale.totalHt) : '---'}}</td>
                                                <td class="text-right">{{sale.tva ? (sale.tva) : '---'}}</td>
                                                <td class="text-right">
                                                    <!-- <span > -->
                                                        {{sale.totalTtc ? (sale.totalTtc) : '---'}}
                                                    <!-- </span> -->
                                                    <!-- <span class="month-total" [ngClass]="{'text-success': sale.monthTotal >= 0, 'text-danger': sale.monthTotal < 0}">
                                                        <strong>{{sale.monthTotal}}</strong>
                                                    </span> -->
                                                </td>
                                                <td>
                                                    <span *ngIf="sale.origineUuid && sale.origineUuid !== '---'">
                                                        <a href="visite/detail/it;cr={{sale.origineUuid}}" class="text-primary">{{sale.origine}}</a>
                                                    </span>
                                                    <span *ngIf="!sale.origine || sale.origine === '---'">
                                                        ---
                                                    </span>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th style="text-align:center; font-weight:bold;">Total :</th>
                                            <th style="text-align:right; font-weight:bold;"></th>
                                            <th></th>
                                            <th style="text-align:right; font-weight:bold;"></th>
                                            <th></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>